import type { ConciergeMessagePart } from '../../types/conciergeToolTypes';
export type { ConciergeMessagePart as MessagePart };

export interface ConciergeMessagePartProps {
  parts: ConciergeMessagePart[];
  onProductClick?: (sku: string) => void;
  isStreaming?: boolean;
  pdpStacklineSku?: string | null;
  isOnChatWidget?: boolean;
  apiBaseUrl?: string;
}

// AI SDK v6 states: input-streaming → input-available → output-available
// Legacy states (pre-v6): partial-call → call → result
export const isCallState = (state?: string): boolean =>
  state === 'call' || state === 'partial-call' || state === 'input-streaming' || state === 'input-available';

export const isOutputState = (state?: string): boolean =>
  state === 'result' || state === 'output-available' || state === 'output' || state === 'complete';
